import React, { useState } from 'react';
import {
  Container,
  Heading,
  PageContent,
  Breadcrumbs,
  Row,
  Col,
  Field,
  Checkbox,
  Button,
  Description,
} from 'components';
import { useTranslation } from 'react-i18next';
import { downloadPm4npPackage } from '../../../api/services/ma';
import { Margin } from 'styled-components-spacing';
import { connect } from 'react-redux';
import { givePm4npConsentCreator } from '../../../store/actionsCreators';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.ma.pm4np',
    url: '/ma/pm4np',
  },
];

const Pm4np = ({ consentGiven, giveConsent }) => {
  const { t } = useTranslation();

  const [isDownloading, setIsDownloading] = useState(false);
  const [personalUse, setPersonalUse] = useState(consentGiven ?? false);
  const [collectConsent, setCollectConsent] = useState(consentGiven ?? false);

  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      if (personalUse && collectConsent && giveConsent) {
        giveConsent();
      }
      await downloadPm4npPackage();
    } catch (error) {
      console.error('Error downloading template:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <PageContent>
      <Container>
        <Breadcrumbs items={breadcrumbs} />
        <Heading as="h1">{t('page.ma.pm4np.title')}</Heading>
        <Margin top="3">{t('page.ma.pm4np.description')}</Margin>
        <Margin top="3">
          <Row>
            <Col>
              <Field id="personalUse">
                <Checkbox selected={personalUse} onChange={() => setPersonalUse(!personalUse)}>
                  {t('page.ma.pm4np.personalUse')}
                </Checkbox>
              </Field>
            </Col>
          </Row>
        </Margin>
        <Margin top="3">
          <Row>
            <Col>
              <Field id="collectConsent">
                <Checkbox
                  selected={collectConsent}
                  onChange={() => setCollectConsent(!collectConsent)}
                >
                  {t('page.ma.pm4np.collectConsent')}
                </Checkbox>
              </Field>
            </Col>
          </Row>
        </Margin>
        <Margin top="3">
          <Row>
            <Col size={{ md: 1 / 2, lg: 1 / 4 }}>
              <Button
                secondary
                disabled={isDownloading || !personalUse || !collectConsent}
                onClick={handleDownload}
              >
                {isDownloading ? t('global.downloading') : t('global.downloadPackage')}
              </Button>
            </Col>
          </Row>
        </Margin>
      </Container>
    </PageContent>
  );
};

const mapStateToProps = ({ user }) => ({
  consentGiven: user.user?.pm4npConsent,
});

const mapDispatchToProps = (dispatch) => ({
  giveConsent: () => dispatch(givePm4npConsentCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Pm4np);
